import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

export default ({ style, ...props }: ViewProps) => (
  <View style={[styles.container, style]} {...props} />
);

const styles = StyleSheet.create({
  container: { flexDirection: 'row' },
});
